module.exports = __webpack_public_path__ + "img/odwh3_v2_element_01.d257fae5.png";